import pageData from '../utils/pageData'
import pageDataNew from '../utils/pageDataNew'
const state = {
  pageData: pageData,
  pageDataNew: pageDataNew,
  isShowServiceAgreement: false,
  keepAlive: ['OrderPrimer', 'OrderGene']
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js